import { isShitDoneToday, isShitDoneThisWeek } from '../constants/shit-functions'

export const doneTypes = {
  DONE_NONE: 'None',
  DONE_TODAY: 'Today',
  DONE_THIS_WEEK: 'This Week',
  DONE_ALL: 'All'
}

export const doneFilters = {
  [doneTypes.DONE_NONE] (shit) {
    return !shit.completedAt
  },
  [doneTypes.DONE_TODAY] (shit) {
    return (isShitDoneToday(shit) || !shit.completedAt)
  },
  [doneTypes.DONE_THIS_WEEK] (shit) {
    return (isShitDoneThisWeek(shit) || !shit.completedAt)
  },
  [doneTypes.DONE_ALL] () {
    return true
  }
}
